export const environment = {
  appName: 'fusus-registry',
  production: true,
};
